<template>
	<db-col class="number-keyboard-wrapper">
		<db-col height="480">
			<db-col width="80%" wrap>
				<db-row width="33.3%" height="25%" v-for="(num, idx) in nums" :key="idx" class="left-btn">
					<db-row class="keyboard-btn" valign="middle" align="center">
						<db-label size="42" bold>{{num}}</db-label>
					</db-row>
				</db-row>
				<db-row width="33.3%" height="25%" class="left-btn">
					<db-row class="keyboard-btn" valign="middle" align="center"></db-row>
				</db-row>
			</db-col>
			<db-row class="auto-fill wrapper">
				<db-row class="auto-fill keyboard-btn right-btn" valign="middle" align="center">
					<db-label size="42" bold>{{num}}</db-label>
				</db-row>
				<db-row class="auto-fill keyboard-btn right-btn" valign="middle" align="center">
					<db-label size="42" bold>{{num}}</db-label>
				</db-row>
			</db-row>
		</db-col>
	</db-col>
</template>

<script>
	export default {
		name: 'keyboard',
		
		props: {
			type: {
				type: String,
				default: ''
			}
		},
		
		data(){
			return {
				nums: [1,2,3,4,5,6,7,8,9,'.',0]
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.number-keyboard-wrapper{
		padding: 20px;
		background: #F5F5F5;
		
		.wrapper{
			padding-bottom: 20px;
		}
		
		.keyboard-btn{
			border-radius: 8px;
			box-shadow: 0 0 14px rgba(#000, .07);
			background: #FFFFFF;
		}
		
		.right-btn{
			margin-bottom: 20px;
			
			&:last-child{
				margin: 0;
			}
		}
		
		.left-btn{
			padding-right: 20px;
			padding-bottom: 20px;
		}
	}
</style>
